var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.375 2c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625v12c0 .345-.28.625-.625.625H3A.625.625 0 0 1 2.375 14V2Zm1.25.625v10.75h8.75V2.625h-8.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.375 5c0-.345.28-.625.625-.625h4a.625.625 0 1 1 0 1.25H6A.625.625 0 0 1 5.375 5ZM5.375 8c0-.345.28-.625.625-.625h4a.625.625 0 1 1 0 1.25H6A.625.625 0 0 1 5.375 8ZM5.375 11c0-.345.28-.625.625-.625h4a.625.625 0 1 1 0 1.25H6A.625.625 0 0 1 5.375 11Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocs);
export default __webpack_public_path__ + "static/media/icon-docs.03b7af59ae52b89c030aab0146b7db9c.svg";
export { ForwardRef as ReactComponent };